 
   


import types from "../actions/actionTypes";
import initialState from "./initialState";


export default function contactsReducer(state = initialState.contactsList, action) {

     const merge = (current, updates) => {       
        let result = current.map(contact => {
            const updateOrNothing = updates.find(pi => pi.id === contact.id);
            if (updateOrNothing !== undefined) {
                return updateOrNothing;
            }
            return contact;
         });   
        const existingIds = result.map(contact => contact.id);
        const newContacts = updates.filter(contact => !existingIds.includes(contact.id));
        return [...result, ...newContacts];   
    }

      const deleteContact = (current, id) => {
        return current.filter(contact => contact.id !== id);
    } 

    switch (action.type) {
        case types.LOAD_CONTACTS_SUCCESS:
            return action.contactsList;
        case types.LOAD_CONTACTS_UPDATE_SUCCESS:
            return merge(state, action.contactsList);
         case types.DELETED_CONTACT:    
            return deleteContact(state, action.id);
        case types.DELETED_CONTACT_INCOMING:
            return deleteContact(state, action.payload.id); 
        default:
            return state;
    }
}

